import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const InstallerService = {
    state: async () => axios.get(`${API_URL}/installer/state`).then(({data}) => data).catch((err) => { throw err }),

    cities: async (q = "") => axios.get(`${API_URL}/installer/cities-with-state`, {params: {q}}).then(({data}) => data).catch((err) => { throw err }),

    streets: async (q = "") => axios.get(`${API_URL}/installer/streets`, {params: {q}}).then(({data}) => data).catch((err) => { throw err }),

    neighborhoods: async (q = "") => axios.get(`${API_URL}/installer/neighborhoods`, {params: {q}}).then(({data}) => data).catch((err) => { throw err }),

    saveCorporation: async (formData) => axios.post(`${API_URL}/installer`, formData).then(({data}) => data).catch((err) => { throw err }),

    saveUser: async (formData) => axios.post(`${API_URL}/installer/user-save`, formData).then(({data}) => data).catch((err) => { throw err }),
};

export default InstallerService;
